export const types = {
  LOG_ERROR: {
    STARTED: 'LOG_ERROR.STARTED',
    FAILURE: 'LOG_ERROR.FAILURE',
    SUCCESS: 'LOG_ERROR.SUCCESS',
  },
};

export const logError = (error, details) => ({
  type: types.LOG_ERROR.STARTED,
  error,
  details,
});



// WEBPACK FOOTER //
// ./redux/actions/errorLogger.js